import {
  BillableItemIds,
  BillableItemPaymentModel,
  BillableItemStatus,
  BillableItemType,
  CurrencyCode,
  FeatureType
} from '../../enums/billableItem';
import { BillableItem, Feature } from '../../interfaces/billableItem';

const basePlanFeatures: Feature[] = [
  { type: FeatureType.PictureMessaging, quantity: 1 },
  { type: FeatureType.PersonalisedLandingPage, quantity: 1 },
  { type: FeatureType.DynamicTemplate, quantity: 1 },
  { type: FeatureType.SubscriberGrowthTool, quantity: 1 },
  { type: FeatureType.TollFreeNumber, quantity: 1 },
  { type: FeatureType['10DlcA2P10DlcShortcode'], quantity: 1 },
  { type: FeatureType.BulkContactUpload, quantity: 1 },
  {
    type: FeatureType.BundledSmsCreditCost,
    quantity: 1,
    priceInCents: 1
  },
  { type: FeatureType.MmsTextOverlay, quantity: 1 }
];

export const shopifyPlans: BillableItem[] = [
  {
    id: BillableItemIds.ShopifyPlan.ShopifyFreeMonthly,
    name: 'Pay As You Go',
    type: BillableItemType.ShopifyPlan,
    priceInCents: 0,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      ...basePlanFeatures,
      {
        type: FeatureType.Contact,
        quantity: 150
      },
      {
        type: FeatureType.PayAsYouGoSmsCreditCost,
        quantity: 1,
        priceInCents: 2
      }
    ]
  },
  {
    id: BillableItemIds.ShopifyPlan.ShopifyPaidMonthly,
    name: 'Growth',
    type: BillableItemType.ShopifyPlan,
    priceInCents: 9900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      ...basePlanFeatures,
      {
        type: FeatureType.Sms,
        quantity: 5000,
        priceInCents: 1.3
      },
      {
        type: FeatureType.Contact,
        quantity: 250000
      },
      {
        type: FeatureType.PayAsYouGoSmsCreditCost,
        quantity: 1,
        priceInCents: 1.3
      },
      { type: FeatureType.CustomDomain, quantity: 1 }
    ]
  }
];
